import _get from 'lodash/get';

export default function sortRefundMethods(methods = []) {
  const methodsMap = methods.reduce((acc, method) => {
    const slug = _get(method, 'payment_method', '');
    acc[slug] = method;
    return acc;
  }, {});

  const { ORIGINAL_PAYMENT_METHOD, GIFT_CARD, ...others } = methodsMap;
  const methodsOrdered = [
    ORIGINAL_PAYMENT_METHOD,
    GIFT_CARD,
    ...Object.values(others)
  ];

  return methodsOrdered.filter(Boolean);
}
